var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-menu"},[_c('menuItem',{attrs:{"menuData":_vm.menuData,"father":_vm.menuData,"navType":_vm.navType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }